import { render, staticRenderFns } from "./ConnectDomainBanner.vue?vue&type=template&id=6ee8087c&scoped=true"
import script from "./ConnectDomainBanner.vue?vue&type=script&lang=js"
export * from "./ConnectDomainBanner.vue?vue&type=script&lang=js"
import style0 from "./ConnectDomainBanner.vue?vue&type=style&index=0&id=6ee8087c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee8087c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ee8087c')) {
      api.createRecord('6ee8087c', component.options)
    } else {
      api.reload('6ee8087c', component.options)
    }
    module.hot.accept("./ConnectDomainBanner.vue?vue&type=template&id=6ee8087c&scoped=true", function () {
      api.rerender('6ee8087c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Banner/MobileBanner/ConnectDomainBanner.vue"
export default component.exports